import styled from 'styled-components';

export const TourContainer_SecNav = styled.div`
  border-bottom: 2px solid #006778;
  border-top: 2px solid #006778;
 
  background: #fff1d0;
 
  z-index: 998;
  width: 100%;
  padding: 10px 0px;
  height: auto;
  @media only screen and (max-width: 1024px) and (min-width: 900px) {
    padding: 0 10px 0 20px;
  }
`;

export const FixedWidth_SecNavbar = styled.div`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const TourTextContainer_SecNav = styled.div`
	width: 1160px;
	height: 20px;
	font-family: HelveticaNeue;
	font-size: 14px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.43;
	letter-spacing: normal;
	color: #505050;
`;

export const OldLink1 = styled.a`
  color: #006778;
  text-decoration: underline;
  width:1px;
  font-weight: bold;
  height: 13px;
  &:hover {
    color: #006778;
    text-decoration: underline;
    width:1px;
  }
`;

export const Seprator = styled.span`
	display:inline-block;
	margin: 0 5px -3px 5px;
	border-left: 1px solid #927474;
	height: 14px;
`;